<script setup>
import SectionTop from "@/components/additional/SectionTop.vue";
import Form from "@/components/base/Form.vue";
</script>

<template>
  <section class="contact-us relative" id="contacts">
    <SectionTop>Contact Us</SectionTop>
    <p class="text-ms relative" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">We’d love to hear from you — whether you're a player, partner, or industry collaborator.</p>
    <Form />

    <img src="../../assets/main.png" alt="section image" class="absolute"/>
    <div class="circle-pink absolute"></div>
    <div class="circle-blue absolute"></div>
    <div class="circle-pink2 absolute"></div>
  </section>
</template>

<style scoped lang="scss">
.contact-us {
  padding: 8.333vw;
  & > p {
    margin: 3.472vw 0 5.625vw;
    color: rgba(255, 255, 255, 0.70);
    width: clamp(423px, 29.375vw, 2250px);
    z-index: 2;
  }
  & > img {
    z-index: 1;
    width: 35%;
    right: -2%;
    bottom: 20%;
  }
  .circle-pink, .circle-pink2, .circle-blue {
    transform: rotate(0);
    width: clamp(486px, 33.75vw, 2500px);
    height: clamp(486px, 33.75vw, 2500px);
  }
  .circle-pink {
    right: -12%;
    top: 10%;
  }
  .circle-blue {
    right: -10%;
    top: 65%;
  }
  .circle-pink2 {
    top: 28%;
    right: 10%;
  }
}
@media (max-width: 768px) {
  .contact-us {
    padding: 50px 24px;
    & > p {
      width: 100%;
      margin: 48px 0 15px;
    }
    & > img {
      position: relative;
      max-width: 400px;
      width: 80%;
      transform: scaleY(-1) scaleX(-1) rotate(-20deg);
      display: block;
      margin: 10% 0 0 15%;
    }
    .circle-pink {
      width: 400px;
      height: 400px;
      background: #413BE4;
      right: auto;
      left: -60px;
      top: 60%;
    }
    .circle-pink2 { display: none; }
    .circle-blue {
      background: #0AFFFB;
      width: 300px;
      height: 300px;
      top: 25%;
      right: -121px;
    }
  }
}
</style>